module.exports = __webpack_public_path__ + "static/media/minus.09a33ee8.svg";